import React from 'react'
import Toast from 'react-bootstrap/Toast'

import './toast.scss'

export enum ToastType {
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum ToastPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
}

const TOAST_COLORS = {
    [ToastType.SUCCESS]: '#28a745',
    [ToastType.ERROR]: '#dc3545',
}

interface ToasterShowProps {
    header?: string
    body: string
    showToaster: boolean
    setShowToaster?: (showToaster: ToasterShowProps['showToaster']) => void
    delay?: number
    autohide?: boolean
    iconColor?: string
    type?: ToastType
    icon?: React.ReactNode
    position?: ToastPosition
}

const Toaster = ({
    header,
    body,
    showToaster = false,
    setShowToaster,
    delay,
    autohide,
    iconColor,
    icon,
    type = ToastType.SUCCESS,
    position = ToastPosition.TOP,
}: ToasterShowProps): React.ReactElement<any> => {
    return (
        <Toast
            autohide={autohide}
            className={`info ${type} ${position}`}
            delay={delay}
            onClose={(): void => setShowToaster && setShowToaster(false)}
            show={showToaster}
        >
            {icon && (
                <span className="toast-icon" style={{ color: iconColor || TOAST_COLORS[type] }}>
                    {icon}
                </span>
            )}
            <div className="toast-text">
                <Toast.Header>{header}</Toast.Header>
                <Toast.Body>{body}</Toast.Body>
            </div>
        </Toast>
    )
}

export default Toaster
